import React from "react";
import LVButtonAccion from "../../Componentes/Basicos/LVButtonAccion";
import LVSelectorChequeReemplazo from "../../Componentes/Selectores/LVSelectorChequeReemplazo";
import LVSelectorFecha from "../../Componentes/Selectores/LVSelectorFecha";
import LVSelectorFechaCuentaFinanciera from "../../Componentes/Selectores/LVSelectorFechaCuentaFinanciera";
import LVSelectorFechaCuentaFinancieraNumerico from "../../Componentes/Selectores/LVSelectorFechaCuentaFinancieraNumerico";
import LVSelectorFechaTexto1Texto2 from "../../Componentes/Selectores/LVSelectorFechaTexto1Texto2";

class CON_Cheques_Detalle extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      data: [],
      loading: true,
      idEstado: 0,
      idCheque: 0,
      showPopupChequeReemplazo: false,
      showPopupSoloFecha: false,
      showPopupFechaCuentaFinanciera: false,
      showPopupFechaCuentaFinancieraNumerico: false,
      showPopupFechaTexto1Texto2: false,
      fechaSeleccionada: null,
      fechaSeleccionadaCompromiso: null,
      cuentaFinancieraSeleccionada: null,
      numericoSeleccionado: 0,
      texto1Seleccionado: "",
      texto2Seleccionado: "",
    };
  }

  getData = async (IdCheque, IdEstado) => {
    // Llama a función asíncrona y maneja los datos
    try {
      this.setState({ loading: false, idCheque: IdCheque, idEstado: IdEstado });
    } catch (error) {
      alert("Error al obtener los datos: " + error);
    }
    this.setState({ loading: false });
  };

  componentDidMount = async () => {
    this.getData(this.props.data.data.IdCheque, this.props.data.data.IdEstado)
  };

  handleOpenSoloFecha = async (e) => {
    this.setState({ showPopupSoloFecha: true, fechaSeleccionada: null });
  };

  handleCloseSoloFecha = () => {
    this.setState({ showPopupSoloFecha: false, fechaSeleccionada: null });
  };
 
  handleOpenFechaCuentaFinanciera = async (e) => {
    this.setState({ showPopupFechaCuentaFinanciera: true, fechaSeleccionada: null, cuentaFinancieraSeleccionada: null });
  };

  handleCloseFechaCuentaFinanciera = () => {
    this.setState({ showPopupFechaCuentaFinanciera: false, fechaSeleccionada: null, cuentaFinancieraSeleccionada: null });
  };

  handleOpenFechaCuentaFinancieraNumerico = async (e) => {
    this.setState({ showPopupFechaCuentaFinancieraNumerico: true, fechaSeleccionada: null, cuentaFinancieraSeleccionada: null, numericoSeleccionado: 0 });
  };

  handleCloseFechaCuentaFinancieraNumerico = () => {
    this.setState({ showPopupFechaCuentaFinancieraNumerico: false, fechaSeleccionada: null, cuentaFinancieraSeleccionada: null, numericoSeleccionado: 0 });
  };

  handleOpenFechaTexto1Texto2 = async (e) => {
    this.setState({ showPopupFechaTexto1Texto2: true, fechaSeleccionada: null, texto1Seleccionado: "", texto2Seleccionado: "" });
  };

  handleCloseFechaTexto1Texto2 = () => {
    this.setState({ showPopupFechaTexto1Texto2: false, fechaSeleccionada: null, texto1Seleccionado: "", texto2Seleccionado: "" });
  };

  handleOpenChequeReemplazo = async (e) => {
    this.setState({ showPopupChequeReemplazo: true, fechaSeleccionada: null, fechaSeleccionadaCompromiso: null, numericoSeleccionado: 0, texto1Seleccionado: "", texto2Seleccionado: "" });
  };

  handleCloseChequeReemplazo = () => {
    this.setState({ showPopupChequeReemplazo: false, fechaSeleccionada: null, fechaSeleccionadaCompromiso: null, numericoSeleccionado: 0, texto1Seleccionado: "", texto2Seleccionado: "" });
  };

  handleConfirmDebitar = async (date) => {
    if (date != null && date != undefined) {
      this.setState({ showPopupSoloFecha: false, fechaSeleccionada: date }, async () => {
        // Esta función se ejecutará después de que se complete el setState
        if (window.confirm("¿Está seguro que desea debitar este cheque? ESTA OPERACIÓN NO SE PODRA DESHACER")) {
          try {
            const { CON_Cheques: { function_CON_Cheques_Debitar } } = require('neftis7_apicaller');
            await function_CON_Cheques_Debitar(this.state.idCheque, this.state.fechaSeleccionada)
            alert("El cheque ha sido debitado correctamente.");
          } catch (error) {
            alert("El cheque no pudo ser debitado." + error);
          }
        }
      });
    } else {
      this.setState({ showPopupSoloFecha: false, fechaSeleccionada: null });
    }
  };

  handleConfirmDepositar = async (date, cuentaFinanciera) => {
    if (date != null && date != undefined) {
      this.setState({ showPopupFechaCuentaFinanciera: false, fechaSeleccionada: date, cuentaFinancieraSeleccionada: cuentaFinanciera }, async () => {
        // Esta función se ejecutará después de que se complete el setState
        if (window.confirm("¿Está seguro que desea depositar este cheque? ESTA OPERACIÓN NO SE PODRA DESHACER")) {
          try {
            const { CON_Cheques: { function_CON_Cheques_Depositar } } = require('neftis7_apicaller');

            await function_CON_Cheques_Depositar(this.state.idCheque, this.state.fechaSeleccionada, this.state.cuentaFinancieraSeleccionada)
            alert("El cheque ha sido depositado correctamente.");
          } catch (error) {
            alert("El cheque no pudo ser depositado." + error);
          }
        }
      });
    } else {
      this.setState({ showPopupFechaCuentaFinanciera: false, fechaSeleccionada: null, cuentaFinancieraSeleccionada: null });
    }
  };

  handleConfirmAcreditar = async (date) => {
    if (date != null && date != undefined) {
      this.setState({ showPopupSoloFecha: false, fechaSeleccionada: date }, async () => {
        // Esta función se ejecutará después de que se complete el setState
        if (window.confirm("¿Está seguro que desea acreditar este cheque? ESTA OPERACIÓN NO SE PODRA DESHACER")) {
          try {
            const { CON_Cheques: { function_CON_Cheques_Acreditar } } = require('neftis7_apicaller');
            await function_CON_Cheques_Acreditar(this.state.idCheque, this.state.fechaSeleccionada)
            alert("El cheque ha sido acreditado correctamente.");
          } catch (error) {
            alert("El cheque no pudo ser acreditado." + error);
          }
        }
      });
    } else {
      this.setState({ showPopupSoloFecha: false, fechaSeleccionada: null });
    }
  };

  handleConfirmRechazar = async (date) => {
    if (date != null && date != undefined) {
      this.setState({ showPopupSoloFecha: false, fechaSeleccionada: date }, async () => {
        // Esta función se ejecutará después de que se complete el setState
        if (window.confirm("¿Está seguro que desea rechazar este cheque? ESTA OPERACIÓN NO SE PODRA DESHACER")) {
          try {
            const { CON_Cheques: { function_CON_Cheques_Rechazar } } = require('neftis7_apicaller');
            await function_CON_Cheques_Rechazar(this.state.idCheque, this.state.fechaSeleccionada)
            alert("El cheque ha sido rechazado correctamente.");
          } catch (error) {
            alert("El cheque no pudo ser rechazado." + error);
          }
        }
      });
    } else {
      this.setState({ showPopupSoloFecha: false, fechaSeleccionada: null });
    }
  };

  handleConfirmNegociar = async (date, cuentaFinanciera, numerico) => {
    if (date != null && date != undefined) {
      this.setState({ showPopupFechaCuentaFinancieraNumerico: false, fechaSeleccionada: date, cuentaFinancieraSeleccionada: cuentaFinanciera, numericoSeleccionado: numerico }, async () => {
        // Esta función se ejecutará después de que se complete el setState
        if (window.confirm("¿Está seguro que desea negociar este cheque? ESTA OPERACIÓN NO SE PODRA DESHACER")) {
          try {
            const { CON_Cheques: { function_CON_Cheques_Negociar } } = require('neftis7_apicaller');
            await function_CON_Cheques_Negociar(this.state.idCheque, this.state.fechaSeleccionada, this.state.cuentaFinancieraSeleccionada, this.state.numericoSeleccionado)
            alert("El cheque ha sido negociado correctamente.");
          } catch (error) {
            alert("El cheque no pudo ser negociado." + error);
          }
        }
      });
    } else {
      this.setState({ showPopupFechaCuentaFinancieraNumerico: false, fechaSeleccionada: null, cuentaFinancieraSeleccionada: null, numericoSeleccionado: 0 });
    }
  };

  handleConfirmReemplazar = async (date, texto1, texto2, dateCompromiso, numerico) => {
    if (date != null && date != undefined) {
      this.setState({
        showPopupChequeReemplazo: false, fechaSeleccionada: date, texto1Seleccionado: texto1, texto2Seleccionado: texto2,
        fechaSeleccionadaCompromiso: dateCompromiso, numericoSeleccionado: numerico
      }, async () => {
        // Esta función se ejecutará después de que se complete el setState
        if (window.confirm("¿Está seguro que desea reemplazar este cheque? ESTA OPERACIÓN NO SE PODRA DESHACER")) {
          try {
            const { CON_Cheques: { function_CON_Cheques_Reemplazar } } = require('neftis7_apicaller');
            await function_CON_Cheques_Reemplazar(this.state.idCheque, this.state.fechaSeleccionada,
              this.state.texto1Seleccionado, this.state.texto2Seleccionado,
              this.state.fechaSeleccionadaCompromiso, this.state.numericoSeleccionado)
            alert("El cheque ha sido reemplazado correctamente.");
          } catch (error) {
            alert("El cheque no pudo ser reemplazado." + error);
          }
        }
      });
    } else {
      this.setState({
        showPopupChequeReemplazo: false, fechaSeleccionada: null, texto1Seleccionado: "", texto2Seleccionado: "",
        fechaSeleccionadaCompromiso: null, numericoSeleccionado: 0
      });
    }
  };

  handleConfirmEditar = async (date) => {
    /*
    if (date != null && date != undefined) {
      this.setState({ showPopupSoloFecha: false, fechaSeleccionada: date }, async () => {
        // Esta función se ejecutará después de que se complete el setState
      if (window.confirm("¿Está seguro que desea editar este cheque? ESTA OPERACIÓN NO SE PODRA DESHACER")) {
        try {
            const { CON_Cheques: {function_CON_Cheques_Editar} } = require('neftis7_apicaller');
          await function_CON_Cheques_Editar(this.state.idCheque, this.state.fechaSeleccionada)
          alert("El cheque ha sido editado correctamente.");
        } catch (error) {
          alert("El cheque no pudo ser editado." + error);
        }
      } 
      });
    } else {
      this.setState({ showPopupSoloFecha: false, fechaSeleccionada: null });
    }
    */
  };

  handleConfirmAdjudicar = async (date, texto1, texto2) => {
    if (date != null && date != undefined) {
      this.setState({ showPopupFechaTexto1Texto2: false, fechaSeleccionada: date, texto1Seleccionado: texto1, texto2Seleccionado: texto2 }, async () => {
        // Esta función se ejecutará después de que se complete el setState
        if (window.confirm("¿Está seguro que desea adjudicar este cheque? ESTA OPERACIÓN NO SE PODRA DESHACER")) {
          try {
            const { CON_Cheques: { function_CON_Cheques_Adjudicar } } = require('neftis7_apicaller');
            await function_CON_Cheques_Adjudicar(this.state.idCheque, this.state.fechaSeleccionada, this.state.texto1Seleccionado, this.state.texto2Seleccionado)
            alert("El cheque ha sido adjudicado correctamente.");
          } catch (error) {
            alert("El cheque no pudo ser adjudicado." + error);
          }
        }
      });
    } else {
      this.setState({ showPopupFechaTexto1Texto2: false, fechaSeleccionada: null, texto1Seleccionado: "", texto2Seleccionado: "" });
    }
  };

  render() {
    return (
      <React.Fragment>
        {this.state.loadingItems ? null : (
          <>
            {this.state.idEstado == 1120 ? (
              <>
                <LVButtonAccion Texto="ACREDITAR" onClick={this.handleOpenSoloFecha} />
                {this.state.showPopupSoloFecha ? (
                  <>
                    <LVSelectorFecha onConfirm={this.handleConfirmAcreditar} onClose={this.handleCloseSoloFecha} />
                  </>
                ) : null}
              </>
            ) : null}

            {this.state.idEstado == 1010 ? (
              <>
                <LVButtonAccion Texto="DEBITAR" onClick={this.handleOpenSoloFecha} />
                {this.state.showPopupSoloFecha ? (
                  <>
                    <LVSelectorFecha onConfirm={this.handleConfirmDebitar} onClose={this.handleCloseSoloFecha} />
                  </>
                ) : null}
              </>
            ) : null}

            {this.state.idEstado == 1110 || this.state.idEstado == 1220 ? (
              <>
                <LVButtonAccion Texto="DEPOSITAR" onClick={this.handleOpenFechaCuentaFinanciera} />
                {this.state.showPopupFechaCuentaFinanciera ? (
                  <>
                    <LVSelectorFechaCuentaFinanciera onConfirm={(date, cuentaFinanciera) => this.handleConfirmDepositar(date, cuentaFinanciera)} onClose={this.handleCloseFechaCuentaFinanciera} />
                  </>
                ) : null}
              </>
            ) : null}

            {this.state.idEstado == 1110 || this.state.idEstado == 1220 ? (
              <>
                <LVButtonAccion Texto="NEGOCIAR" onClick={this.handleOpenFechaCuentaFinancieraNumerico} />
                {this.state.showPopupFechaCuentaFinancieraNumerico ? (
                  <>
                    <LVSelectorFechaCuentaFinancieraNumerico onConfirm={(date, cuentaFinanciera, numerico) => this.handleConfirmNegociar(date, cuentaFinanciera, numerico)} onClose={this.handleCloseFechaCuentaFinancieraNumerico} />
                  </>
                ) : null}
              </>
            ) : null}

            {this.state.idEstado == 1010 || this.state.idEstado == 1120 || this.state.idEstado == 1140 || this.state.idEstado == 1150 || this.state.idEstado == 1230 ? (
              <>
                <LVButtonAccion Texto="RECHAZAR" onClick={this.handleOpenSoloFecha} />
                {this.state.showPopupSoloFecha ? (
                  <>
                    <LVSelectorFecha onConfirm={this.handleConfirmRechazar} onClose={this.handleCloseSoloFecha} />
                  </>
                ) : null}
              </>
            ) : null}

            {this.state.idEstado == 1210 ? (
              <>
                <LVButtonAccion Texto="REEMPLAZAR" onClick={this.handleOpenChequeReemplazo} />
                {this.state.showPopupChequeReemplazo ? (
                  <>
                    <LVSelectorChequeReemplazo onConfirm={(date, texto1, texto2, dateCompromiso, numerico) => this.handleConfirmReemplazar(date, texto1, texto2, dateCompromiso, numerico)} onClose={this.handleCloseChequeReemplazo} />
                  </>
                ) : null}
              </>
            ) : null}

            {this.state.idEstado == 1010 || this.state.idEstado == 1020 || this.state.idEstado == 1110 || this.state.idEstado == 1120 ||
              this.state.idEstado == 1130 || this.state.idEstado == 1140 || this.state.idEstado == 1150 || this.state.idEstado == 1210 ||
              this.state.idEstado == 1220 ? (
              <>
                <LVButtonAccion Texto="EDITAR" onClick={this.handleEditarOnClick} />
              </>
            ) : null}

            {this.state.idEstado == 1010 || this.state.idEstado == 1110 ? (
              <>
                <LVButtonAccion Texto="ADJUDICAR" onClick={this.handleOpenFechaTexto1Texto2} />
                {this.state.showPopupFechaTexto1Texto2 ? (
                  <>
                    <LVSelectorFechaTexto1Texto2 onConfirm={(date, texto1, texto2) => this.handleConfirmAdjudicar(date, texto1, texto2)} onClose={this.handleCloseFechaTexto1Texto2} />
                  </>
                ) : null}
              </>
            ) : null}
          </>
        )}

      </React.Fragment>
    );
  }
}

export default CON_Cheques_Detalle;
